export function normalizeUserRights(userRights) {
  if (!Array.isArray(userRights)) return [];
  return userRights.map(String);
}

export function filterRoutesByRights(routes, userRights) {
  const normalizedRights = normalizeUserRights(userRights);

  return routes.filter(route => {
    if (route.accessRight) {
      return normalizedRights.includes(String(route.accessRight));
    }
    return true;
  });
}

